import React, { useEffect, useState } from "react";
import { Card } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import RecordNotFound from "src/components/RecordNotFound";
import { htmlDecode } from "src/utils/convertHtml";
import { s3baseUrl } from "src/config/config";
import { clickAbleUrl } from "src/utils/constants";
import {
  AddCommentAPI,
  DeleteComment,
  DeleteCommentImageOnS3,
  UpdateCommentAPI,
  UploadCommentImageOnS3,
} from "src/DAL/SupportTicket/Comments";
import { useSnackbar } from "notistack";
import CustomConfirmation from "src/components/GeneralComponents/CustomConfirmation";
import CustomPopover from "src/components/GeneralComponents/CustomPopover";
import moment from "moment";
var moment_tz = require("moment-timezone");

import {
  capitalizeFirst,
  get_date_with_user_time_zone,
} from "src/utils/constants";

import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
} from "src/assets";
import TinyEditor from "src/components/GeneralComponents/Ckeditor";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import ModelBox from "src/components/ModalBox/ImageModalBox";
import {
  addAssessmentListApi,
  deleteAssessmentListApi,
  editAssessmentListApi,
} from "src/DAL/AssessmentApi/assessmentApi";

function ChatCardAssessment({
  comments,
  ticket_id,
  list_data,
  supportTicketData,
  hideImageBox,
  Assessment_type,
}) {
  const [open, setOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [files, setFiles] = useState([]);
  const [oldImagesArray, setOldImagesArray] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [commentId, setCommentId] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const { userInfo, adminTimeZone } = useContentSetting();
  const [shortDescriptionCk, setShortDescriptionCk] = useState("");
  const [showButtons, setShowButtons] = React.useState({
    addButton: true,
    editButton: false,
  });
  const handleOpen = (image_path) => {
    setImageUrl(image_path);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleRemove = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };
  const handleUpload = (event) => {
    let setImageObject = {};
    const fileList = event.target.files;
    const arr = [];

    for (let i = 0; i < fileList.length; i++) {
      setImageObject = {
        path: fileList[i],
        type: "file",
        extension: fileList[i].type,
      };

      arr.push(setImageObject);
    }
    setFiles((prevFiles) => [...prevFiles, ...arr]);
  };

  //Deleting Note
  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    let postData = {
      internal_note_type: Assessment_type,
      assessment_id: ticket_id,
      internal_note_id: commentId,
    };
    const result = await deleteAssessmentListApi(postData);
    if (result.code === 200) {
      list_data();
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  //Getting Note In textarea
  const handleEdit = (comment) => {
    // console.log(comment, "commentcommentcommentcomment");
    setShortDescriptionCk(comment.internal_note_message);
    setCommentId(comment._id);
    setShowButtons({
      addButton: false,
      editButton: true,
    });
    let setImageObject = {};
    comment.comment_image?.map((images, index) => {
      setImageObject = {
        thumbnail_1: images.thumbnail_1,
        thumbnail_2: images.thumbnail_2,
        type: "image",
      };
      files.push(setImageObject);
      oldImagesArray.push(setImageObject);
    });
  };

  const handleCancelUpdate = () => {
    setShortDescriptionCk("");
    setCommentId("");
    setShowButtons({
      addButton: true,
      editButton: false,
    });
    setFiles([]);
  };

  const handleAgreeDelete = (comment) => {
    setCommentId(comment._id);
    setOpenDelete(true);
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    },

    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];
  const MENU_OPTIONS1 = [
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];

  const UploadImages = async (formData) => {
    const result = await UploadCommentImageOnS3(formData);
    return result.image_path;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const results = files.map((image, index) => {
      const formData = new FormData();
      formData.append("image", image.path);
      const result = UploadImages(formData);
      return result;
    });

    Promise.all(results).then(async (img_results) => {
      var setImageArray = [];
      img_results.map((image_path, index) => {
        setImageArray.push(image_path);
      });
      const formDataObject = {
        assessment_id: ticket_id,
        internal_note_type: Assessment_type,
        internal_note_message: shortDescriptionCk,
      };
      if (files.length > 0) {
        formDataObject.comment_image = setImageArray;
      }
      const result = await addAssessmentListApi(JSON.stringify(formDataObject));
      if (result.code === 200) {
        setIsLoading(false);
        list_data();
        setShortDescriptionCk("");
        setFiles([]);
        enqueueSnackbar(result.message, { variant: "success" });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    });
  };

  const DeleteImages = async (formData) => {
    const result = await DeleteCommentImageOnS3(formData);
    return result;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const deleted_images_array = [];
    let deleted_images_object = {};
    oldImagesArray.map((old_image, index) => {
      const filtered_array = files.filter(
        (image, index) => image.thumbnail_1 == old_image.thumbnail_1
      );
      delete old_image.type;
      if (filtered_array.length == 0) {
        deleted_images_array.push(old_image);
      }
    });
    if (deleted_images_array.length > 0) {
      deleted_images_object = {
        moment_image: deleted_images_array,
      };
      const result = DeleteImages(deleted_images_object);
    }

    const results = files.map((image, index) => {
      if (image.type === "file") {
        const formData = new FormData();
        formData.append("image", image.path);
        const result = UploadImages(formData);
        return result;
      } else {
        return image;
      }
    });

    Promise.all(results).then(async (img_results) => {
      var setImageArray = [];
      img_results.map((image_path, index) => {
        setImageArray.push(image_path);
      });
      const formDataObject = {
        assessment_id: ticket_id,
        internal_note_type: Assessment_type,
        internal_note_message: shortDescriptionCk,
        internal_note_id: commentId,
      };
      if (files.length > 0) {
        formDataObject.comment_image = setImageArray;
      }
      const result = await editAssessmentListApi(formDataObject);
      if (result.code === 200) {
        list_data();
        setShortDescriptionCk("");
        setFiles([]);
        setCommentId("");
        setShowButtons({
          addButton: true,
          editButton: false,
        });
        setIsLoading(false);
        enqueueSnackbar(result.message, { variant: "success" });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    });
  };

  const imageLinks = {
    docx: wordImage,
    mp3: audioImage,
    pdf: pdfImage,
    csv: csvImage,
    doc: docImage,
    xlsx: xlsxImage,
    xls: xlsxImage,
    other: otherImage,
  };

  const getCommentRecourse = (file) => {
    const ext = file.thumbnail_1.split(".").pop();
    if (
      ext == "jpg" ||
      ext == "JPG" ||
      ext == "png" ||
      ext == "webp" ||
      ext == "jpeg" ||
      ext == "JPEG" ||
      ext == "PNG"
    ) {
      return s3baseUrl + file.thumbnail_2;
    } else if (imageLinks[ext]) {
      return imageLinks[ext];
    } else {
      return imageLinks.other;
    }
  };

  const getCommentImage = (file) => {
    if (file.type === "file") {
      const ext = file.path.name.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return URL.createObjectURL(file.path);
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    } else {
      const ext = file.thumbnail_2.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return s3baseUrl + file.thumbnail_2;
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    }
  };
  moment.tz.setDefault(userInfo.time_zone);
  console.log(comments, "commentscommentscomments");
  return (
    <div className="col-12">
      <Card className="chat-main-card p-2 mt-3">
        <div className=" parent-container chat-message-box">
          {comments?.length > 0 ? (
            comments.map((comment, i) => {
              const comment_date = get_date_with_user_time_zone(
                comment.note_date_time,
                "YYYY-MM-DD hh:mm A",
                userInfo.time_zone,
                adminTimeZone
              );
              return (
                <>
                  {/* ok */}
                  <div className="mini-cards d-flex">
                    <div className="w-100 ms-2 me-2">
                      <div className="diary-font-weight d-flex">
                        <h4 className="headingMain">
                          {comment.action_user_info.action_name}
                        </h4>
                        <div className="d-flex menu-container">
                          <span
                            className="diary-first-heading pe-2"
                            style={{ paddingTop: 3, fontSize: "12px" }}
                          >
                            {comment_date}
                          </span>

                          {userInfo._id ==
                            comment.action_user_info.action_id && (
                            <CustomPopover menu={MENU_OPTIONS} data={comment} />
                          )}
                          {/* {comment.action_user_info.action_by ===
                          "consultant_user" ? (
                            <CustomPopover menu={MENU_OPTIONS} data={comment} />
                          ) : (
                            ""
                          )} */}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between ml-3  diary-first-heading">
                        <div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: comment.internal_note_message,
                            }}
                            className="diary-para mt-2"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ok end */}
                </>
              );
            })
          ) : (
            <RecordNotFound title="Notes " />
          )}
        </div>
        <form onSubmit={showButtons.addButton ? handleSubmit : handleUpdate}>
          <div className="col-12 mt-4">
            <h4>Enter Message* </h4>
            <TinyEditor
              setDetailDescription={setShortDescriptionCk}
              detailDescriptionCk={shortDescriptionCk}
            />
          </div>
          <div className="w-100 px-3 d-flex">
            <div className="row w-100 mb-3 add-photo">
              {hideImageBox == true ? (
                ""
              ) : (
                <p className="mt-3 mb-0">Recommended Size (1000x670)</p>
              )}

              {files &&
                files.map((file, index) => (
                  <div className="col-sm-3 col-md-2 col-lg-1 mt-2 ms-2 p-0">
                    <span className="preview">
                      <span onClick={() => handleRemove(index)}>x</span>
                      <img src={getCommentImage(file)} />
                    </span>
                  </div>
                ))}
              {hideImageBox == true ? (
                ""
              ) : (
                <div className="col-sm-3 col-md-2 col-lg-1 mt-2">
                  <span className="upload-button">
                    <input
                      color="primary"
                      type="file"
                      id="icon-button-file"
                      style={{ display: "none" }}
                      onChange={handleUpload}
                      multiple={true}
                      accept="image/*,.pdf,.xlsx,.xls,.docx,.csv,.doc"
                    />
                    <label htmlFor="icon-button-file">
                      <CloudUploadIcon />
                    </label>
                  </span>
                </div>
              )}
            </div>
          </div>
          {showButtons.addButton === true &&
            (supportTicketData.ticket_status === 0 ? (
              <button
                type="submit"
                className="mt-2 float-end small-contained-button mb-4 me-4"
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Send"}
              </button>
            ) : (
              <button
                type="submit"
                className="mt-2 float-end small-contained-button disabled mb-4 me-4"
                disabled={true}
              >
                Send
              </button>
            ))}
          {showButtons.editButton === true && (
            <div className="d-flex justify-content-end mb-4 me-4">
              <button
                className="mt-2 me-2 small-contained-button"
                onClick={handleCancelUpdate}
              >
                Cancel
              </button>
              <button
                className="mt-2 small-contained-button"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Update"}
              </button>
            </div>
          )}
          <CustomConfirmation
            open={openDelete}
            setOpen={setOpenDelete}
            title={"Are you sure you want to delete this Note?"}
            handleAgree={handleDelete}
          />
        </form>
      </Card>
      <ModelBox open={open} handleClose={handleClose} image_url={imageUrl} />
    </div>
  );
}

export default ChatCardAssessment;
